module.exports = ":host{height:var(--global-inner-wrapper-height)}"